import { Component, EventEmitter, HostBinding, Input, OnChanges, Output } from '@angular/core';
import { FADE_IN_OUT_ANIMATION } from 'src/app/shared/animations/animations';

@Component({
    selector: 'gl-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    animations: [FADE_IN_OUT_ANIMATION],
    standalone: false
})
export class NotificationsComponent implements OnChanges {
  public timeout: NodeJS.Timeout;
  @HostBinding('@show') public show;
  @Input() public text: string;
  @Input() public type: 'good' | 'danger' | 'warning' | 'normal';
  @Input() public timeToClose: number;
  @HostBinding('class') public class: string;
  @Output() private closeNotification = new EventEmitter();

  public ngOnChanges() {
    this.class = this.type;
    if (this.timeToClose) {
      this.timeout = setTimeout(() => {
        this.close();
      }, this.timeToClose);
    }
  }

  public close() {
    clearTimeout(this.timeout);
    this.closeNotification.emit();
  }
}
